import type { VChartSpecPipeline } from 'src/types'
import {
  initColumn,
  barCornerRadius,
  barMaxWidth,
  colorAdapter,
  color,
  linearColor,
  backgroundColor,
  playerColumn,
  progressive,
  label,
  brush,
  tooltip,
  discreteLegend,
  colorLegend,
  horizontalCrosshairRect,
  colorBarStyleFill,
  columnStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  xBand,
  yLinear,
  datasetXY,
  isPlayer,
  fontFamilyTheme,
} from '../pipes'

const raceColumn: VChartSpecPipeline = [
  fontFamilyTheme,
  initColumn,
  barCornerRadius,
  barMaxWidth,
  colorAdapter(color, linearColor),
  backgroundColor,
  isPlayer(playerColumn, datasetXY),
  progressive,
  xBand,
  yLinear,

  label,
  brush,
  tooltip({ titleEncoding: 'x' }),
  colorAdapter(discreteLegend, colorLegend),
  horizontalCrosshairRect,
  colorBarStyleFill(columnStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
]

export const raceColumnSpecPipeline = raceColumn
